import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export function Section({
  title,
  description,
  children,
  action,
  className,
}: {
  title: string;
  description?: string;
  children: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <section className={cn('mb-8', className)}>
      <div className="flex items-end justify-between mb-3">
        <div>
          <h2 className="text-lg font-semibold leading-tight">{title}</h2>
          {description && <p className="text-sm text-ducens-muted mt-0.5">{description}</p>}
        </div>
        {action}
      </div>
      {children}
    </section>
  );
}
